// extracted by mini-css-extract-plugin
export var articleContainer = "article-module--article-container--4gM7n";